import { Button, Flex, Heading, Text } from "@/ui";
import { t } from "@/utils";
import NavigationBar from "@/components/NavigationBar";
import Lottie from "@/components/Lottie";
import onboarding2 from "assets/animations/onboarding2.lottie?url";
import { WizardProps } from "../Wizard";

export default function InstallOnOtherDevice({ next, push }: WizardProps) {
  return (
    <Flex grow={1} direction="column" alignItems="center" minH={0}>
      <NavigationBar
        onBack={() => push("add-camera", { stepDirection: "previous" })}
        props={{ my: "1rem", justifyContent: "center" }}
      >
        <Heading as="h6">{t("stepOf", { 0: 1, 1: 3 })}</Heading>
      </NavigationBar>
      <Flex grow={1} shrink={1} overflow="hidden">
        <Lottie src={onboarding2} textSlots={{ Get: t("get")?.toUpperCase() }} />
      </Flex>
      <Flex direction="column" alignItems="center">
        <Text variant="title2" color="error" mt="24">
          {t("pairing.onSecondDevice")}
        </Text>
        <Heading my="12" as="h4">
          {t("pairing.add.camera.step1")}
        </Heading>
        <Text>
          {t("notSureHowToInstall", {
            a: (
              <Button
                variant="link"
                color="primary"
                onClick={() =>
                  push("device-select", {
                    stepDirection: "next",
                    stateUpdate: { previousStepId: "install-on-other-device" }
                  })
                }
              />
            )
          })}
        </Text>
      </Flex>
      <Button mt="60" bg="primary" color="on-primary" minW="18.5rem" onClick={() => next()}>
        {t("buttons.continue")}
      </Button>
    </Flex>
  );
}
